galleryHandler = {
    $panelCarousel: $('.panel-carousel'),
      
    init: function() {
        var self = this;
        this.$panelCarousel.each(function(){
            var $carouselMain = $(this).find('.carousel-main');
            var $carouselNav = $(this).find('.carousel-nav');
            var $carouselContainer = $(this).find('.carousel-container');
            var dataId = $carouselMain.data('id');            

            $carouselMain.flickity({
                cellAlign: 'left',
                pageDots: false,
                contain: true,
                wrapAround: SVGComponentTransferFunctionElement,
                /* fullscreen: true,
                lazyLoad: 1 */
            });
    
            $carouselNav.flickity({
                asNavFor: ".carousel-main[data-id="+dataId+"]", 
                contain: true, 
                pageDots: false,
                prevNextButtons: false,
                wrapAround: true
            });

            var $carouselGallery = $carouselContainer.find('.carousel-images').flickity({
                cellAlign: 'center',
                dragThreshold: 30,
                wrapAround: true,
                pageDots: false,
                adaptiveHeight: true,
                fullscreen: true,
                prevNextButtons: true,
                autoPlay: 0, 
                imagesLoaded: true,
                resize: true,
                fullscreen: false
            });

            // $carouselMain.find('.carousel-cell').on('click', function(e) {
            //     $carouselGallery.flickity('select', $(this).index());
            //     $carouselContainer.addClass('is-show');
            // });

            $carouselMain.on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
                $carouselGallery.flickity('select', cellIndex);
                $carouselContainer.addClass('is-show');
                // if ( !cellElement ) {
                //   return;
                // }
                // // change cell background with .is-clicked
                // $carouselMain.find('.flickity-fullscreen-button-view').click();
              });

        })
    }
}